const PERMISSION_TRAINING_SLOTS = {
    CREATE: "training.slots.create",
    GET: "training.slots.get",
    LIST: "training.slots.list",
    UPDATE: "training.slots.update",
    DELETE: "training.slots.delete",
};

const PERMISSION_TRAINING_LEVELS = {
    CREATE: "training.levels.create",
    GET: "training.levels.get",
    LIST: "training.levels.list",
    UPDATE: "training.levels.update",
    DELETE: "training.levels.delete",
};

const PERMISSION_TRAINING_CLASSROOMS = {
    CREATE: "training.classrooms.create",
    GET: "training.classrooms.get",
    LIST: "training.classrooms.list",
    UPDATE: "training.classrooms.update",
    DELETE: "training.classrooms.delete",
};

const PERMISSION_TRAINING_COURSES = {
    CREATE: "training.courses.create",
    GET: "training.courses.get",
    LIST: "training.courses.list",
    UPDATE: "training.courses.update",
    DELETE: "training.courses.delete",
};

const PERMISSION_TRAINING_CLASSES = {
    CREATE: "training.classes.create",
    GET: "training.classes.get",
    LIST: "training.classes.list",
    UPDATE: "training.classes.update",
    DELETE: "training.classes.delete",
};

const PERMISSION_TRAINING_TEACHERS = {
    CREATE: "training.teachers.create",
    GET: "training.teachers.get",
    LIST: "training.teachers.list",
    UPDATE: "training.teachers.update",
    DELETE: "training.teachers.delete",
};

const PERMISSION_TRAINING_SCHEDULE = {
    CREATE: "training.schedule.create",
    GET: "training.schedule.get",
    LIST: "training.schedule.list",
    UPDATE: "training.schedule.update",
    DELETE: "training.schedule.delete",
};

const PERMISSION_TRAINING_EVENTS = {
    CREATE: "training.events.create",
    GET: "training.events.get",
    LIST: "training.events.list",
    UPDATE: "training.events.update",
    DELETE: "training.events.delete",
};

const PERMISSION_TRAINING_SESSIONS = {
    CREATE: "training.sessions.create",
    GET: "training.sessions.get",
    LIST: "training.sessions.list",
    UPDATE: "training.sessions.update",
    DELETE: "training.sessions.delete",
};

const PERMISSION_TRAINING_ATTANDANCES = {
    CREATE: "training.attendances.create",
    GET: "training.attendances.get",
    LIST: "training.attendances.list",
    UPDATE: "training.attendances.update",
    DELETE: "training.attendances.delete",
};

const PERMISSION_TRAINING_STUDENTS = {
    CREATE: "training.students.create",
    GET: "training.students.get",
    LIST: "training.students.list",
    UPDATE: "training.students.update",
    DELETE: "training.students.delete",
};

const PERMISSION_TRAINING_SLOT_CHANGE_REQUESTS = {
    CREATE: "training.slot_change_requests.create",
    GET: "training.slot_change_requests.get",
    LIST: "training.slot_change_requests.list",
    UPDATE: "training.slot_change_requests.update",
    DELETE: "training.slot_change_requests.delete",
    APPLY: "training.slot_change_requests.apply",
};

const PERMISSION_TRAINING_STUDENT_OBSERVATIONS = {
    CREATE: "training.student_observations.create",
    LIST: "training.student_observations.list",
    DELETE: "training.student_observations.delete",
    NOTIFY: "training.student_observations.notify",
};

const PERMISSION_TRAINING_REGISTRATION = {
    CREATE: "training.registrations.create",
    GET: "training.registrations.get",
    LIST: "training.registrations.list",
    UPDATE: "training.registrations.update",
    DELETE: "training.registrations.delete",
};

const PERMISSION_TRAINING_CONTRACTS = {
    CREATE: "training.contracts.create",
    GET: "training.contracts.get",
    LIST: "training.contracts.list",
    UPDATE: "training.contracts.update",
    DELETE: "training.contracts.delete",
};

const PERMISSION_TRAINING_PAYMENTS = {
    CREATE: "training.payments.create",
    GET: "training.payments.get",
    LIST: "training.payments.list",
    UPDATE: "training.payments.update",
    DELETE: "training.payments.delete",
};

const PERMISSION_SCHOOL_MEMBERS = {
    CREATE: "school.members.create",
    GET: "school.members.get",
    LIST: "school.members.list",
    UPDATE: "school.members.update",
    DELETE: "school.members.delete",
};

const PERMISSION_TRAINING_TASKS = {
    IMPORT_FROM_TRAINING: "training.tasks.import-from-training",
    IMPORT_CALENDAR_BANK_HOLIDAYS: "training.tasks.import-calendar-bank-holidays",
    GENERATE_SCHEDULE_SESSIONS: "training.tasks.generate-schedule-sessions",
    GENERATE_SCHEDULE_ENTRIES: "training.tasks.generate-schedule-entries",
    IMPORT_LEVELSCLASSES_FROM_EXCEL_FILE: "training.tasks.import-levelsclasses-from-excel-file",
    IMPORT_REGISTRATIONS_FROM_EXCEL_FILE: "training.tasks.import-registrations-from-excel-file",
    IMPORT_REGISTRATIONS_FROM_TRAINING: "training.tasks.import-registrations-from-training",
    EXPORT_STUDENTS_TO_EXCEL_FILE: "training.tasks.export-students-to-excel-file",
    UPDATE_REGISTRATIONS_STATUS: "training.tasks.update-registrations-status",
    UPDATE_REGISTRATIONS_CLASS: "training.tasks.update-registrations-class",
};

const PERMISSION_SCHOOL_TRAININGS = {
    CREATE: "school.trainings.create",
    GET: "school.trainings.get",
    LIST: "school.trainings.list",
    UPDATE: "school.trainings.update",
    DELETE: "school.trainings.delete",
};

const PERMISSION_SCHOOL_POLICIES = {
    RESET: "school.policies.reset",
    LIST: "school.policies.list",
    UPDATE: "school.policies.update",
};

const PERMISSION_SCHOOL_DETAILS = {
    GET: "school.details.get",
    UPDATE: "school.details.update",
};

const PERMISSION_TRAINING_CAMPAIGNS = {
    CREATE: "training.campaigns.create",
    GET: "training.campaigns.get",
    LIST: "training.campaigns.list",
    UPDATE: "training.campaigns.update",
    DELETE: "training.campaigns.delete",
};

const PERMISSION_TRAINING_CAMPAIGN_MAILS = {
    GET: "training.campaigns.mails.get",
    LIST: "training.campaigns.mails.list",
};

module.exports = {
    PERMISSION_TRAINING_SLOTS,
    PERMISSION_TRAINING_LEVELS,
    PERMISSION_TRAINING_CLASSROOMS,
    PERMISSION_TRAINING_COURSES,
    PERMISSION_TRAINING_CLASSES,
    PERMISSION_TRAINING_TEACHERS,
    PERMISSION_TRAINING_SCHEDULE,
    PERMISSION_TRAINING_EVENTS,
    PERMISSION_TRAINING_SESSIONS,
    PERMISSION_TRAINING_ATTANDANCES,
    PERMISSION_TRAINING_STUDENTS,
    PERMISSION_TRAINING_SLOT_CHANGE_REQUESTS,
    PERMISSION_TRAINING_STUDENT_OBSERVATIONS,
    PERMISSION_TRAINING_REGISTRATION,
    PERMISSION_TRAINING_CONTRACTS,
    PERMISSION_TRAINING_PAYMENTS,
    PERMISSION_TRAINING_TASKS,

    PERMISSION_SCHOOL_TRAININGS,
    PERMISSION_SCHOOL_MEMBERS,
    PERMISSION_SCHOOL_POLICIES,
    PERMISSION_SCHOOL_DETAILS,

    PERMISSION_TRAINING_CAMPAIGNS,
    PERMISSION_TRAINING_CAMPAIGN_MAILS,
};

